import React from 'react';
import BuildImg from '../images/Home/hlz-BuildingB.jpg';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './HlzBrief.css';

export function HlzBrief() {
  // console.log("get into HlzBrief()");
  return (
    <section id='hlzbriefs' className='hlzbrief-block'>
      <Container fluid>
        <h2 className='text-center'>---About HLZ Technology---</h2>
        <Row style={{ marginTop: '1%' }}> {
          <Row>
            <Col lg={6} className='justify-content-center d-lg-flex'>
              <img src={BuildImg} style={{ height: 'auto' }} alt="hlz-BuildingB.jpg" />
            </Col>
            <Col lg={6} className='d-lg-flex flex-column justify-content-center'>
              <h3 className='mb-3 fw-bold text-center'>关于合利资光电科技</h3>
              <p className='hlzbrief'>东莞市合利资光电科技有限公司，成立于2013年，至今超过10年</p>
              <p className='hlzbrief'>对于触摸屏的研发，生产，销售拥有丰富的经验</p>
              <p className='hlzbrief'>工厂集成了2.4~65寸功能片，TPM，TDM全贴合的完整生产线</p>
              <p className='hlzbrief'>产品远销海内外，并可依照您的产品应用提供客制化的服务</p>
              <p className='hlzbrief'>应用于工控，医疗，智能家居，航空航天，教育，POS，交通运输</p>
              <p className='hlzbrief'>我们致力于打造成一流的触摸屏制造商，以满足客户的多样化需求</p>
              <br />
              <Link to="/AboutUs" className='d-flex justify-content-center'>
                <button className='btn btn-success btn-lg fs-4'>More About Us</button>
              </Link>
            </Col>
          </Row>
        } </Row>
      </Container>
    </section>
  );
}

export default HlzBrief;